import React from "react";
import "./OurMissionStyle.scss";
import { ourMissionTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const OurMissionSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="our-mission-section">
      <div className="our-mission-wrap">
        <SectionHeading>{ourMissionTextContent.headingText}</SectionHeading>

        <div className="our-mission-box">
          <div className="our-mission-container">
            <div className="img-box">
              <img src={ourMissionTextContent.imageSrc} alt="Images" />
            </div>

            <div className="text-box">
              {ourMissionTextContent.content.map((section, index) =>
                section.listContent_1 && section.listContent_1.length > 0 ? (
                  <ul className="list-text-box" key={index}>
                    {section.listContent_1.map((item, itemIndex) => (
                      <li className="list-text" key={itemIndex}>
                        {item.listText}
                      </li>
                    ))}
                  </ul>
                ) : null
              )}
              
              {ourMissionTextContent.content.map((section, index) =>
                section.listContent_2 && section.listContent_2.length > 0 ? (
                  <ul className="list-text-box" key={index}>
                    {section.listContent_2.map((item, itemIndex) => (
                      <li className="list-text" key={itemIndex}>
                        {item.listText}
                      </li>
                    ))}
                  </ul>
                ) : null
              )}
            </div>
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={ourMissionTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurMissionSection;
